// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"41315186","5":"cde09725","113":"4fd6dc22","453":"f488a80e","493":"2b001b2d","671":"40095da0"}[chunkId] + ".chunk.js";
};